import { Link } from "react-router-dom";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(1200px circle at top left, color-mix(in srgb, var(--c3) 45%, white 55%) 0%, transparent 38%), linear-gradient(180deg, #f8fcfd 0%, #ffffff 100%)",
};

const shellStyle = {
  background: "#fff",
  border: "1px solid var(--hairline)",
  borderRadius: "20px",
  padding: "2.5rem", // Increased padding for a more "document" feel
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
  width: "100%",
};

const sectionTitleStyle = {
  fontSize: "1.5rem",
  fontWeight: "700",
  color: "#1e293b",
  marginTop: "2rem",
  marginBottom: "1rem",
};

const listStyle = {
  paddingLeft: "1.5rem",
  marginBottom: "1rem",
};

export default function PrivacyPolicy() {
  return (
    <main style={pageStyle}>
      <div
        className="container"
        style={{
          paddingTop: "2rem",
          paddingBottom: "4rem",
          paddingLeft: "clamp(1rem, 4vw, 1.5rem)",
          paddingRight: "clamp(1rem, 4vw, 1.5rem)",
          maxWidth: "800px", // Keeps the text readable and centered
          margin: "0 auto",
        }}
      >
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            marginBottom: "2rem",
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "0.85rem",
                fontWeight: 800,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "var(--ink-muted)",
              }}
            >
              BeFitFriends
            </div>
            <h1 style={{ margin: "0.25rem 0 0", fontSize: "clamp(2rem, 4vw, 3rem)" }}>
              Privacy Policy
            </h1>
          </div>

          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.85rem 1.1rem",
              borderRadius: "999px",
              border: "1px solid var(--hairline)",
              background: "#fff",
              fontWeight: 700,
              textDecoration: "none",
              color: "inherit",
            }}
          >
            Back home
          </Link>
        </header>

        <section
          style={{
            ...shellStyle,
            padding: "clamp(1.1rem, 4vw, 2.5rem)",
          }}
        >
          <div style={{ color: "var(--ink-muted)", marginBottom: "2rem" }}>
            <strong>Last Updated:</strong> April 10, 2026
          </div>

          <p>
            Welcome to BeFitFriends! We designed this policy to be clear and easy to understand 
            because we want you to know exactly how your data helps us find your next workout partner.
          </p>

          <h2 style={sectionTitleStyle}>1. Information We Collect</h2>
          <p>We can't help you find "FitFriends" without some information about you.</p>
          <ul style={listStyle}>
            <li><strong>Account Data:</strong> Basics like your name, city, state, email, and date of birth. We currently do not collect phone numbers but may in the future.</li>
            <li><strong>Profile Data:</strong> Gender, fitness interests, approximate location, and workout goals.</li>
            <li><strong>Verification Data:</strong> School-issued email or proof of enrollment for student-specific features.</li>
            <li><strong>Content:</strong> Profile photos and messages sent within the app.</li>
            <li><strong>Geolocation:</strong> With permission, we may collect GPS data. You can disable this in device settings at any time.</li>
            <li><strong>Device Data:</strong> Technical info like IP address and device ID for app stability.</li>
          </ul>

          <h2 style={sectionTitleStyle}>2. How We Use Your Information</h2>
          <ul style={listStyle}>
            <li>Create and manage your account.</li>
            <li>Recommend workout partners and activities near you.</li>
            <li>Provide chat features and group management.</li>
            <li>Verify student status for exclusive chats.</li>
            <li>Maintain safety by detecting and preventing fraud.</li>
          </ul>

          <h2 style={sectionTitleStyle}>3. How Do We Share Your Information</h2>
          <p>We do not sell your personal information to data brokers or third-party advertisers.</p>
          <ul style={listStyle}>
            <li><strong>With Other Users:</strong> Public profile data (name, age, city/state, interests) is visible to other members.</li>
            <li><strong>Activity Creators:</strong> Creators can see your name and photo to manage attendance.</li>
            <li><strong>Service Providers:</strong> Trusted partners for hosting, analytics, and payments.</li>
            <li><strong>Legal Requirements:</strong> Shared only if required by law or to protect member safety.</li>
          </ul>

          <h2 style={sectionTitleStyle}>4. Data Retention & Your Rights</h2>
          <p><strong>Retention:</strong> We keep data as long as your account is active. Upon deletion, we begin removal processes, though limited records may be kept for legal audits.</p>
          <p><strong>Your Rights:</strong> You can access and update info in App settings. Residents of states like Florida and California have specific rights to request data copies or deletion.</p>

          <h2 style={sectionTitleStyle}>5. Contact Us</h2>
          <address style={{ fontStyle: "normal", marginTop: "1rem", lineHeight: "1.6" }}>
            <strong>BeFitFriends LLC</strong><br />
            Email: <a href="mailto:support@befitfriends.com">support@befitfriends.com</a>
          </address>
        </section>
      </div>
    </main>
  );
}